import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {
  ExtensionActivityType,
  ExtensionEvent, Hort360GrowerProperty,
  Hort360Property,
  Hort360PropertySummary
} from '../../../../functions/src/types';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {ApiService} from '../../services/api.service';
import {RSDialogService} from '../../../libs/rsnotify/rsdialog.service';
import {LocalStorageService} from '@efaps/ngx-store';
import {PropertyService} from '../../services/property.service';
import {MatTableDataSource} from '@angular/material/table';
import {DataService, ResolveCategory} from '../../services/data.service';
import invert from 'invert-color';
import {RSDialog} from '../../../libs/rsnotify/rsdialog';
import {AddActivityComponent} from '../add-activity/add-activity.component';
import defaultValues = RSDialog.defaultValues;
import {RSLoadingModalService} from '../../../libs/rsloading/rsloading.service';
import {AddEventComponent} from '../add-event/add-event.component';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {ActivatedRoute, Router} from "@angular/router";
import {Subscription} from "rxjs";
import {ViewEventComponent} from "../view-event/view-event.component";
import * as XLSX from "xlsx";
import * as moment from "moment";

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss']
})
export class EventsComponent implements OnInit, OnDestroy {
  public isSearching = false;
  private events: ExtensionEvent[] = [];
  public searchResults: ExtensionEvent[] | null = null;
  public searchCategory: string | null; // Id
  private searchEvent = null;
  private lastSearch = null;
  @Input('searchTerm') public searchTerm = '';
  @Output('selected') selected = new EventEmitter<ExtensionEventDisplay>();

  displayedColumns: string[] = ['date', 'name', 'category', 'properties', 'attendees', 'edit'];
  dataSource = null;
  private dataSort = null;
  private dataPaginator = null;
  @ViewChild(MatSort) set sort(sort: MatSort) {
    this.dataSort = sort;
    if (this.dataSort && this.dataSource) {
      this.dataSource.sort = this.dataSort;
    }
  }
  @ViewChild(MatPaginator) set paginator(paginator: MatPaginator) {
    this.dataPaginator = paginator;
    if (this.dataPaginator && this.dataSource) {
      this.dataSource.paginator = this.dataPaginator;
    }
  }

  private eventsSub: Subscription;

  constructor(
    private apiService: ApiService,
    private rsDialog: RSDialogService,
    private lsService: LocalStorageService,
    public dataService: DataService,
    private rsDialogService: RSDialogService,
    public loadingService: RSLoadingModalService,
    public resolveCategory: ResolveCategory,
    public fbDB: AngularFirestore,
    public propertyService: PropertyService,
    private route: ActivatedRoute
  ) {
    if (this.route.snapshot.params && this.route.snapshot.params.id) {
      this.searchTerm = this.route.snapshot.params.id;
    }
    this.eventsSub = this.dataService.events.subscribe(v => {
      this.events = v;
      this.searchEvents();
    });
  }

  public searchEvents() {
    this.searchTerm = this.searchTerm.trim();
    const searchEvent = +new Date();
    this.searchEvent = searchEvent;
    this.lastSearch = this.searchTerm;
    this.lsService.set('eventSearch', this.searchTerm);
    this.searchResults = null;
    this.isSearching = true;
    setTimeout(() => {
      try {
        if (searchEvent !== this.searchEvent) {
          return;
        }
        const lowerSearch = this.searchTerm.toLowerCase();
        this.searchResults = this.events
          // Filter to category
          .filter(e => {
            return !this.searchCategory || this.searchCategory === e.category;
          })
          .map(e => {
            const category = this.resolveCategory.transform(e.category);
            return {
              ...e,
              userName: e.user,
              categoryName: category.name,
              categoryColor: category.color,
              categoryIcon: category.icon,
            } as ExtensionEventDisplay;
          })
          .filter(e => {
            return !this.searchTerm ||
              (
                (e.id + '').toLowerCase().indexOf(lowerSearch) !== -1 ||
                (e.userName + '').toLowerCase().indexOf(lowerSearch) !== -1 ||
                (e.categoryName + '').toLowerCase().indexOf(lowerSearch) !== -1 ||
                (e.name + '').toLowerCase().indexOf(lowerSearch) !== -1 ||
                (e.notes + '').toLowerCase().indexOf(lowerSearch) !== -1
              );
          });
        this.dataSource = new MatTableDataSource(this.searchResults);
        this.dataSource.sort = this.dataSort;
        this.dataSource.paginator = this.dataPaginator;
        this.isSearching = false;
      } catch (e) {
        console.error(e);
        this.rsDialog.showErrorDialog('Something went wrong. Please try again. ' + e.message);
        this.isSearching = false;
      }
    });
  }

  invertColor(hex) {
    return invert(hex || '#ffffff', true);
  }

  async selectEvent(event: ExtensionEventDisplay) {
    try {
      const attendees = await this.fbDB.collection(`events/${event.id}/attendees`).get().toPromise();
      const attendeeIds = attendees.docs.map(d => d.id + '');
      const selectedProperties = this.propertyService.getPropertySummaries(attendeeIds);

      const dialogOptions = new RSDialog.Options(RSDialog.Type.PROMPT, false);
      dialogOptions.title = event.name || 'Event';
      dialogOptions.cancelable = true;
      dialogOptions.closeButton = true;
      dialogOptions.size = RSDialog.Size.LARGE;
      dialogOptions.style = RSDialog.Style.SUCCESS;

      // Add our custom component;
      dialogOptions.component = ViewEventComponent;

      // Use an old fashioned object to assign variable values to;
      const propertyAttendees: {[key: number]: number} = {};
      attendees.docs.forEach(d => propertyAttendees[d.id] = (d.data() || {} as any).total || 1);
      const oValues: {event: ExtensionEvent, properties: Hort360PropertySummary[], propertyAttendees: {[key: number]: number} } = {event, properties: selectedProperties, propertyAttendees };

      console.log('updateEvent::: values:: ', oValues);
      dialogOptions.values = oValues;

      this.rsDialogService.showDialog(dialogOptions).then(() => {}, () => {});

    } catch (e) {
      this.rsDialogService.showErrorDialog('Something went wrong. ' + e.message);
    }
  }

  ngOnInit(): void {
    this.searchTerm = this.lsService.get('eventSearch') || '';
    this.searchEvents();
  }

  async deleteEvent(eventId) {
    const bDelete = await this.rsDialogService.showConfirmDialog('Are you sure you want to delete this event?', false, 'Delete Event', RSDialog.Style.WARN);
    if (!bDelete) {
      return;
    }
    this.loadingService.show();
    try {
      await this.dataService.deleteEvent(eventId);
    } catch (e) {
      this.rsDialogService.showErrorDialog('Something went wrong. Please try again. ' + e.message);
    }
    this.loadingService.hide();
  }

  async downloadEvent(eventId) {
    console.log('downloadEvent::: ', eventId);

    // Wait for the results;
    this.loadingService.show();
    try {
      const event = this.dataService.events.value.find(c => c.id === eventId);
      const attendees = await this.fbDB.collection(`${this.dataService.eventsRef.ref.path}/${event.id}/attendees`).get().toPromise();
      const attendingProperties = attendees.docs.map(p => p.id);
      const getProperties = attendingProperties.map(p => this.propertyService.getProperty(p));
      function reflect(promise) {
        return promise.then(
          (v) => {
            return { status: 'fulfilled', value: v };
          },
          (error) => {
            return { status: 'rejected', reason: error };
          }
        );
      }
      const gotProperties = await Promise.all(getProperties.map(p => reflect(p[1])));
      const attendeeInfo = [];
      attendees.docs.forEach((a, i) => {
        const promise = gotProperties[i];
        const propertySummary: Hort360PropertySummary = getProperties[i][0] || {} as Hort360PropertySummary;
        let property: Hort360GrowerProperty = {} as Hort360GrowerProperty;
        if (promise.value) {
          property = promise.value || {};
        }

        attendeeInfo.push({
          propertyId: property?.id || propertySummary?.id || a.id,
          propertyAttendees: (a.data() || {} as any).total || 0,
          propertyAddress: propertySummary?.address || 'UNKNOWN',
          propertyCatchment: propertySummary?.catchment || 'UNKNOWN',

          growerId: propertySummary?.growerId || 'UNKNOWN',
          growerMobile: property?.mobile || '',
          growerPhone: property?.phone || '',
          growerABN: property?.abn || '',
          growerCompany: property?.company || '',
          growerEmailAddress: property?.emailaddress || '',
        });
      });

      // Build the WB
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(attendeeInfo);
      const safeName = (event.name + ' Attendees').replace(/[\W_]+/g, '_').substr(0, 30);
      XLSX.utils.book_append_sheet(wb, ws, safeName);
      const result = XLSX.writeFile(wb, `Event-${safeName}-${moment().format('X')}.xlsx`); // Save to file
      console.log(result);
    } catch (e) {
      this.rsDialogService.showErrorDialog('Something went wrong. ' + (e.message ? e.message : e));
    }
    this.loadingService.hide();
  }

  async updateEvent(eventId) {
    console.log('updateEvent::: ', eventId);

    const dialogOptions = new RSDialog.Options(RSDialog.Type.PROMPT, true);
    dialogOptions.title = 'Extension Workshop / Field Day ';
    dialogOptions.cancelable = false;
    dialogOptions.closeButton = false;
    dialogOptions.size = RSDialog.Size.LARGE;
    dialogOptions.style = RSDialog.Style.SUCCESS;

    // Add our custom component;
    dialogOptions.component = AddEventComponent;

    // Use an old fashioned object to assign variable values to;
    const oValues: {event: ExtensionEvent, propertyAttendees: {[key: number]: number} } =
                   {
                     event: this.dataService.events.value.find(c => c.id === eventId) || {} as ExtensionEvent,
                     propertyAttendees: {}
                   };

    console.log('updateEvent::: values:: ', oValues);
    dialogOptions.values = oValues;

    this.rsDialogService.showDialog(dialogOptions).then(
      async (v) => {
        console.log(v, oValues);
        if (v === defaultValues.YES) {
          this.loadingService.show();

          try {
            const propertyAttendees = {};
            Object.keys(oValues.propertyAttendees).forEach(id => propertyAttendees[id] = oValues.propertyAttendees[id] || 0);
            await this.dataService.addUpdateEvent(oValues.event, propertyAttendees);
          } catch (e) {
            this.rsDialogService.showErrorDialog('Something went wrong. Please try again. ' + e.message);
          }

          this.loadingService.hide();
          this.searchEvents();
        }
      },
      (e) => console.error
    );
  }

  ngOnDestroy() {
    if (this.eventsSub) {
      this.eventsSub.unsubscribe();
    }
  }

}

interface ExtensionEventDisplay extends ExtensionEvent {
  userName: string;
  categoryName: string;
  categoryColor: string;
}
